(function(){
  const textEl = document.getElementById('breadcrumb-text');
  if (!textEl) return;
  const original = textEl.textContent.trim();
  const container = textEl.parentElement; // <nav class="breadcrumb">

  function truncate() {
    // 1) Remettre le texte en l'état
    textEl.textContent = original;

    // 2) Largeur totale du container
    const containerWidth = container.clientWidth;

    // 3) Somme des largeurs des frères (Home, separator, collection…)
    let used = 0;
    Array.from(container.children).forEach(el => {
      if (el === textEl) return;
      used += el.offsetWidth;
    });

    // 4) Espace dispo pour breadcrumb-text (on retire un petit pad de sécurité)
    const available = containerWidth - used - 4;

    // 5) Tronquer mot à mot jusqu'à tenir dans available
    const words = original.split(' ');
    while (textEl.scrollWidth > available && words.length > 1) {
      words.pop();
      textEl.textContent = words.join(' ') + '…';
    }
  }

  // Debounce simple
  function debounce(fn, ms) {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  // Si la page est déjà chargée, on tronque ; sinon on attend window.load
  if (document.readyState === 'complete') {
    truncate();
  } else {
    window.addEventListener('load', truncate);
  }

  // Re-troncature au resize
  window.addEventListener('resize', debounce(truncate, 150));
})();